// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".institution-chip[data-v-bfd6b14a]{border:1px solid}.semi-transparent[data-v-bfd6b14a]{opacity:.5}.word-break-smart[data-v-bfd6b14a]{word-wrap:break-word;word-wrap:anywhere}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
